import { Form, Formik } from 'formik'
import { fonts } from 'shared/lib'
import styled from 'styled-components'
import * as Yup from 'yup'

import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'
import { t } from 'localization'
import { Button } from 'shared/components/Button'
import FormikInput from 'shared/components/Input/FormikInput'
import Spinner from 'shared/components/Spinner'
import { CheckoutQA } from 'shared/dataAttributes'

const TP = 'checkout.PromotionPanel'

const Disclaimer = styled.div`
  ${fonts.BODY_TEXT}
  margin: 20px 0;
`

const PromoInput = styled(FormikInput)`
  input {
    text-transform: uppercase;
  }
`

const PromotionForm = () => {
  const { activatePromotion, order, panels } = useCheckoutContext()
  const { loading } = panels.promotion

  const validationSchema = Yup.object({
    code: Yup.string(),
  })

  return (
    <Spinner
      showSpinner={loading}
      text={loading ? t(`${TP}.spinnerText`, 'Checking promos...') : ''}
      subText={loading ? t(`${TP}.spinnerSubText`, 'Please do not close your browser!') : ''}
    >
      <Formik
        initialValues={{ code: '' }}
        onSubmit={({ code }, { setFieldError }) =>
          activatePromotion({ code, orderNumber: order?.orderNumber!, setFieldError })
        }
        validationSchema={validationSchema}
      >
        {({ dirty, isValid }) => (
          <Form>
            <PromoInput
              type="input"
              title={t(`${TP}.code`, 'Enter Promo Code')}
              name="code"
              qaAttr={CheckoutQA.PromotionBox}
            />
            <Disclaimer data-qa={CheckoutQA.PromotionDisclaimerText}>
              {t(`${TP}.disclaimer`, 'Limit one promotion per transaction')}
            </Disclaimer>
            <Button
              $fill
              buttonType="primary1"
              type="submit"
              disabled={!(isValid && dirty)}
              qaAttr={CheckoutQA.PromotionSubmitButton}
            >
              {t(`${TP}.apply`, 'Apply')}
            </Button>
          </Form>
        )}
      </Formik>
    </Spinner>
  )
}

export default PromotionForm
